(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("HAlertModalController", HAlertModalController);

    HAlertModalController.$inject = ['$scope', 'modalData'];

    function HAlertModalController($scope, modalData) {

        var self = this;
        self.data = modalData;

        self.close = function () {
            modalData.onHide?.();
            $scope.$hide();
        };

        if (self.data['button']) {
            self.data['button']['text'] = self.data['button']['text'] || 'Cancel';
            self.data['button']['confirm_button_class'] = self.data['button']['confirm_button_class'] || 'h-sm-blue-solid-btn';
            self.data['button']['cancel_button_class'] = self.data['button']['cancel_button_class'] || 'h-sm-blue-outline-btn';
        }
    }
})();